module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e1326145"
    }
  }, [_c('b', [_vm._v("CHORIZO AND "), _c('br'), _vm._v(" BLACK BEAN NACHOS")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e1326945"
    }
  }, [_c('b', [_c('i', [_vm._v("These are serious nachos for chile lovers. Be sure to use fully cooked chorizo links, not soft bulk-style chorizo.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1327945"
    }
  }, [_c('b', [_vm._v("Prep: 20 minutes        Bake: 5 minutes per batch")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1328445"
    }
  }, [_vm._v("36 unbroken large tortilla chips")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1328745"
    }
  }, [_vm._v("3 large ripe plum tomatoes, cut into")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1329045"
    }
  }, [_vm._v("¼-inch pieces")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1329945"
    }
  }, [_vm._v("⅓ cup chopped fresh cilantro")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1330945"
    }
  }, [_vm._v("¼ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1331845"
    }
  }, [_vm._v("1 tablespoon vegetable oil")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1332145"
    }
  }, [_vm._v("1 fully cooked chorizo sausage (3 ounces), finely "), _c('br'), _vm._v(" chopped, or ¾ cup finely chopped pepperoni "), _c('br'), _vm._v(" (3 ounces)")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1333945"
    }
  }, [_vm._v("1 medium onion, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1334345"
    }
  }, [_vm._v("1 garlic clove, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1334645"
    }
  }, [_vm._v("½ teaspoon ground cumin")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1335545"
    }
  }, [_vm._v("1 can (15 to 19 ounces) black beans, "), _c('br'), _vm._v(" rinsed and drained")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1336245"
    }
  }, [_vm._v("4 ounces Monterey Jack cheese, shredded (1 cup)")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1336545"
    }
  }, [_vm._v("2 pickled jalapeño chiles, very thinly sliced")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e1337045"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" Preheat oven to 400°F. Arrange as many tortilla chips as will fit in single layer on two ungreased large cookie sheets. In small bowl, combine tomatoes, cilantro, and salt.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1338745"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" In 10-inch skillet, heat oil over medium heat. Add chorizo, onion, garlic, and cumin; cook, stirring, until onion is tender, about 5 minutes. Stir in beans and heat through.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1340645"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Place 1 tablespoon bean mixture on each tortilla chip. Sprinkle cheese over beans and top each nacho with 1 slice jalapeño. Bake until cheese begins to melt, about 5 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1342345"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("4.")])]), _vm._v(" Spoon about 1 teaspoon tomato mixture on each nacho. Transfer nachos to platter. Makes 36 nachos.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e1343645"
    }
  }, [_vm._v("Each nacho: About 51 calories, 2g protein, 4g carbohydrate, 3g total fat (1g saturated), 5mg cholesterol, 112mg sodium.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c34795f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c35_r1.vue
// module id = 171
// module chunks = 0